export * from './fileSize.pipe';
export * from './newline.pipe';
export * from './pipes.module';
